//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DocumentMailSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetIsSendingEnabledDocumentMailSettingsQueryParameters = {
  subtenantId: number ;
}

export type GetDocumentMailSettingsDocumentMailSettingsQueryParameters = {
  subtenantId: number ;
}

export type PatchDocumentMailSettingsDocumentMailSettingsQueryParameters = {
  subtenantId: number ;
}

export function getIsSendingEnabledUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/mail/settings/documents/{subtenantId}/enabled";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getIsSendingEnabledDefaultOptions: Omit<UseQueryOptions<boolean, unknown, boolean>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<boolean, unknown, boolean>, 'queryFn'>> = {
};
export function getGetIsSendingEnabledDefaultOptions() {
  return getIsSendingEnabledDefaultOptions;
};
export function setGetIsSendingEnabledDefaultOptions(options: typeof getIsSendingEnabledDefaultOptions) {
  getIsSendingEnabledDefaultOptions = options;
}

export function getIsSendingEnabledQueryKey(subtenantId: number): QueryKey;
export function getIsSendingEnabledQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { subtenantId,  } = params[0] as GetIsSendingEnabledDocumentMailSettingsQueryParameters;

    return trimArrayEnd([
        'DocumentMailSettingsClient',
        'getIsSendingEnabled',
        subtenantId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentMailSettingsClient',
        'getIsSendingEnabled',
        ...params
      ]);
  }
}
export function __getIsSendingEnabled(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getIsSendingEnabled(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetIsSendingEnabledQuery<TSelectData = boolean, TError = unknown>(dto: GetIsSendingEnabledDocumentMailSettingsQueryParameters, options?: Omit<UseQueryOptions<boolean, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets Enabled field from settings for a subtenant.
 */
export function useGetIsSendingEnabledQuery<TSelectData = boolean, TError = unknown>(subtenantId: number, options?: Omit<UseQueryOptions<boolean, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetIsSendingEnabledQuery<TSelectData = boolean, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<boolean, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let subtenantId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ subtenantId,  } = params[0] as GetIsSendingEnabledDocumentMailSettingsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [subtenantId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<boolean, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getIsSendingEnabled(context, axiosConfig) : __getIsSendingEnabled,
    queryKey: getIsSendingEnabledQueryKey(subtenantId),
    ...getIsSendingEnabledDefaultOptions as unknown as Omit<UseQueryOptions<boolean, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets Enabled field from settings for a subtenant.
 */
export function setGetIsSendingEnabledData(queryClient: QueryClient, updater: (data: boolean | undefined) => boolean, subtenantId: number) {
  queryClient.setQueryData(getIsSendingEnabledQueryKey(subtenantId),
    updater
  );
}

/**
 * Gets Enabled field from settings for a subtenant.
 */
export function setGetIsSendingEnabledDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: boolean | undefined) => boolean) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getDocumentMailSettingsUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/mail/settings/documents/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDocumentMailSettingsDefaultOptions: Omit<UseQueryOptions<Types.DocumentMailSettingsDto, unknown, Types.DocumentMailSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DocumentMailSettingsDto, unknown, Types.DocumentMailSettingsDto>, 'queryFn'>> = {
};
export function getGetDocumentMailSettingsDefaultOptions() {
  return getDocumentMailSettingsDefaultOptions;
};
export function setGetDocumentMailSettingsDefaultOptions(options: typeof getDocumentMailSettingsDefaultOptions) {
  getDocumentMailSettingsDefaultOptions = options;
}

export function getDocumentMailSettingsQueryKey(subtenantId: number): QueryKey;
export function getDocumentMailSettingsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { subtenantId,  } = params[0] as GetDocumentMailSettingsDocumentMailSettingsQueryParameters;

    return trimArrayEnd([
        'DocumentMailSettingsClient',
        'getDocumentMailSettings',
        subtenantId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentMailSettingsClient',
        'getDocumentMailSettings',
        ...params
      ]);
  }
}
export function __getDocumentMailSettings(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDocumentMailSettings(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetDocumentMailSettingsQuery<TSelectData = Types.DocumentMailSettingsDto, TError = unknown>(dto: GetDocumentMailSettingsDocumentMailSettingsQueryParameters, options?: Omit<UseQueryOptions<Types.DocumentMailSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets document settings for a subtenant.
 */
export function useGetDocumentMailSettingsQuery<TSelectData = Types.DocumentMailSettingsDto, TError = unknown>(subtenantId: number, options?: Omit<UseQueryOptions<Types.DocumentMailSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDocumentMailSettingsQuery<TSelectData = Types.DocumentMailSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DocumentMailSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let subtenantId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ subtenantId,  } = params[0] as GetDocumentMailSettingsDocumentMailSettingsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [subtenantId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DocumentMailSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDocumentMailSettings(context, axiosConfig) : __getDocumentMailSettings,
    queryKey: getDocumentMailSettingsQueryKey(subtenantId),
    ...getDocumentMailSettingsDefaultOptions as unknown as Omit<UseQueryOptions<Types.DocumentMailSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets document settings for a subtenant.
 */
export function setGetDocumentMailSettingsData(queryClient: QueryClient, updater: (data: Types.DocumentMailSettingsDto | undefined) => Types.DocumentMailSettingsDto, subtenantId: number) {
  queryClient.setQueryData(getDocumentMailSettingsQueryKey(subtenantId),
    updater
  );
}

/**
 * Gets document settings for a subtenant.
 */
export function setGetDocumentMailSettingsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DocumentMailSettingsDto | undefined) => Types.DocumentMailSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchDocumentMailSettingsUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/mail/settings/documents/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchDocumentMailSettingsMutationKey(subtenantId: number): MutationKey {
  return trimArrayEnd([
      'DocumentMailSettingsClient',
      'patchDocumentMailSettings',
      subtenantId as any,
    ]);
}

/**
 * Patches document settings for a subtenant.
 */
export function usePatchDocumentMailSettingsMutation<TContext>(subtenantId: number, options?: Omit<UseMutationOptions<void, unknown, Types.DocumentMailSettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.DocumentMailSettingsPatchDto, TContext> {
  const key = patchDocumentMailSettingsMutationKey(subtenantId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.DocumentMailSettingsPatchDto) => Client.patchDocumentMailSettings(subtenantId, dto),
    mutationKey: key,
  });
}
  
type PatchDocumentMailSettings__MutationParameters = PatchDocumentMailSettingsDocumentMailSettingsQueryParameters & {
  dto: Types.DocumentMailSettingsPatchDto;
}

/**
 * Patches document settings for a subtenant.
 */
export function usePatchDocumentMailSettingsMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PatchDocumentMailSettings__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchDocumentMailSettingsDocumentMailSettingsQueryParameters}): UseMutationResult<void, unknown, PatchDocumentMailSettings__MutationParameters, TContext> {
  const key = patchDocumentMailSettingsMutationKey(options?.parameters?.subtenantId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PatchDocumentMailSettings__MutationParameters) => Client.patchDocumentMailSettings(data.subtenantId ?? options?.parameters?.subtenantId!, data.dto),
  mutationKey: key,
});
}